'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

var _AbstractField2 = require('./AbstractField');

var _AbstractField3 = _interopRequireDefault(_AbstractField2);

var _Utils = require('./../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Field pro editaci dokladu.
 */
var SubjektDokladField = function (_AbstractField) {
    (0, _inherits3.default)(SubjektDokladField, _AbstractField);

    function SubjektDokladField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SubjektDokladField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubjektDokladField.__proto__ || (0, _getPrototypeOf2.default)(SubjektDokladField)).call.apply(_ref, [this].concat(args))), _this), _this.getInputValue = function (value) {
            return value ? value.dokladCislo ? value.dokladCislo : "" : "";
        }, _this.getObjValue = function (e) {
            var _this$props = _this.props,
                value = _this$props.value,
                typDoklad = _this$props.typDoklad;


            var objValue = void 0;
            if (value) {
                objValue = (0, _extends3.default)({
                    typDoklad: typDoklad }, value, {
                    dokladCislo: e.target.value
                });
            } else {
                objValue = {
                    typDoklad: typDoklad,
                    dokladCislo: e.target.value
                };
            }

            return objValue;
        }, _this.handleOnChange = function (e) {
            var onChange = _this.props.onChange;

            onChange(_this.getObjValue(e));
        }, _this.handleBlur = function (e) {
            var onBlur = _this.props.onBlur;

            onBlur(_this.getObjValue(e));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SubjektDokladField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                addonsBefore = _props.addonsBefore,
                addonsAfter = _props.addonsAfter,
                onChange = _props.onChange,
                onBlur = _props.onBlur,
                typDoklad = _props.typDoklad,
                value = _props.value,
                props = (0, _objectWithoutProperties3.default)(_props, ['addonsBefore', 'addonsAfter', 'onChange', 'onBlur', 'typDoklad', 'value']);


            var field = _react2.default.createElement(_reactstrap.Input, (0, _extends3.default)({
                type: 'text',
                onChange: this.handleOnChange,
                onBlur: this.handleBlur,
                value: this.getInputValue(value)
            }, props));

            return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
        }
    }]);
    return SubjektDokladField;
}(_AbstractField3.default);

SubjektDokladField.PropTypes = {
    // Typ dokladu, konstanta z EnumTypDoklad
    typDoklad: _react2.default.PropTypes.string.isRequired,
    // Objekt typu SubjektDokladRO
    value: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string]), // string musí být, protože při prázdném poli dává redux prázdný string, místo objektu!
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};
exports.default = SubjektDokladField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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